module.exports = __webpack_public_path__ + "img/popupAd-day9.246392f7.png";